// src/pages_unauth/ResetPasswordPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignupPage.css"; // reuse same styles as Signin/Signup
import { useAuth } from "../context/AuthContext"; // adjust path if needed

export default function ResetPasswordPage() {
  const { sendPasswordReset } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!email) {
      setError("Por favor, insira seu e-mail.");
      return;
    }

    try {
      setLoading(true);
      await sendPasswordReset(email);

      setMessage(
        "Enviamos um e-mail com instruções para redefinir sua senha. Verifique sua caixa de entrada e o spam."
      );
    } catch (err) {
      console.error("Erro ao enviar e-mail de redefinição:", err);

      if (err.code === "auth/user-not-found") {
        setError("Não encontramos uma conta com este e-mail.");
      } else if (err.code === "auth/invalid-email") {
        setError("Por favor, insira um e-mail válido.");
      } else {
        setError("Ocorreu um erro ao enviar o e-mail. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sign-container">
      <div className="sign-card">
        <h2 className="sign-header">Esqueceu sua senha?</h2>
        <p className="sign-subtitle">Sem problema — acontece com todo mundo!</p>

        {error && <p className="error">{error}</p>}
        {message && <p className="success">{message}</p>}

        <form className="sign-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="E-mail"
            className="sign-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" className="sign-button" disabled={loading}>
            {loading ? "Enviando..." : "Enviar link de redefinição"}
          </button>
        </form>

        <button
          type="button"
          className="sign-secondary-button"
          onClick={() => navigate("/signin")}
        >
          Voltar ao login
        </button>
      </div>
    </div>
  );
}

